import Paging from "src/app/model/api/generic/paging";
import ImagenParametroClass from "src/app/model/api/inspecciones/imagenParametroClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class ImagenesParametrosTable extends DatabaseTable<ImagenParametroClass> {

  public async getAll(): Promise<ImagenParametroClass[]> {
    return await this.GetAllRecords()
  }

  public async getById(Id: number): Promise<ImagenParametroClass> {
    let records = await this.GetRecordsById(0, 1, Id, Id)
    if (records.length) {
      return records[0]
    }
    return null
  }

  public async getByCodigo(Codigo: string): Promise<ImagenParametroClass[]> {
    return await this.GetRecordsByIndex(0, Number.MAX_VALUE, 'Codigo', Codigo, Codigo)
  }

  public async getCountByCodigo(Codigo: string): Promise<number> {
    return await this.GetRecordsCountIndex('Codigo', Codigo, Codigo)
  }

  public async getPagedByCodigo(start: number, limit: number, Codigo: string): Promise<Paging<ImagenParametroClass>> {
    let count = await this.GetRecordsCountIndex('Codigo', Codigo, Codigo)
    let data = await this.GetRecordsByIndex(start, limit, 'Codigo', Codigo, Codigo)

    let result = new Paging<ImagenParametroClass>()
    result.page = Math.floor(start / limit) + 1
    result.total = count
    result.totalPages = Math.ceil(result.total / limit)
    result.collection = data
    result.count = data.length
    return result
  }

  public async getPaged(start: number, limit: number): Promise<Paging<ImagenParametroClass>> {
    let count = await this.GetRecordsCount()
    let data = await this.GetRecordsPage(start, limit)

    let result = new Paging<ImagenParametroClass>()
    result.page = Math.floor(start / limit) + 1
    result.total = count
    result.totalPages = Math.ceil(result.total / limit)
    result.collection = data
    result.count = data.length
    return result
  }

  public async update(record: ImagenParametroClass): Promise<void> {
    await this.UpdateRecord(record)
  }

  public async delete(record: ImagenParametroClass): Promise<void> {
    await this.DeleteRecord(record.LocalId)
  }

  public async deleteById(Id: number): Promise<void> {
    if (!Id) return
    await this.DeleteRecord(Id)
  }

}
